/**
 * IdentityVaultIndicator - Indicador do Cofre de Identidade
 * 
 * - Posição: canto inferior esquerdo
 * - Barra de progresso 0-100%
 * - Animação de "respiração"
 */

import React from 'react';
import { Lock } from 'lucide-react';

export default function IdentityVaultIndicator({
  progress = 0,
  onClick,
}) {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 left-6 z-40 flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 hover:scale-105 group"
      style={{
        background: 'rgba(255, 251, 245, 0.9)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(180, 160, 130, 0.2)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}
      title="Cofre de Identidade"
    >
      {/* Lock icon with breathing animation */}
      <div 
        className="relative"
        style={{ animation: 'breathe 3s ease-in-out infinite' }}
      >
        <Lock 
          size={18} 
          className="text-amber-600"
          strokeWidth={2}
        />
        {/* Glow effect */}
        <div 
          className="absolute inset-0 rounded-full opacity-30"
          style={{
            background: 'radial-gradient(circle, #fbbf24 0%, transparent 70%)',
            animation: 'pulse 2s ease-in-out infinite',
          }}
        />
      </div>

      {/* Progress bar */}
      <div className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider text-stone-400">
          Cofre
        </span>
        <div className="w-16 h-1.5 rounded-full bg-stone-200 overflow-hidden">
          <div 
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${clampedProgress}%`,
              background: 'linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%)',
            }}
          />
        </div>
      </div>

      {/* Percentage */}
      <span className="text-xs font-medium text-amber-700 group-hover:text-amber-800">
        {clampedProgress}%
      </span>

      <style>{`
        @keyframes breathe {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.2); }
        }
      `}</style>
    </button>
  );
}
